namespace RS
{
    /**
     * Implements a local storage class, this allows the game to load and save information from the localStorage object.
     */
    export class Storage
    {
        private static _gameName;
        private static _version;

        /**
         * Initialised the localStorage object, specify a game name to ensure we write to storage for our game.
         */
        public static init(gameName: string, version: string)
        {
            this._gameName = gameName;
            this._version = version;
        }

        /**
         * Saves a value to local storage. Objects will be converted to a JSON string before being stored.
         */
        public static save<T>(key: string, value: T, core: boolean = false)
        {
            const saveValue = JSON.stringify(value);
            localStorage.setItem(Storage.getKey(key, core), saveValue);
        }

        /**
         * Loads a value from local storage.
         */
        public static load<T>(key: string, defaultValue: T, core: boolean = false) : T
        {
            const value = localStorage.getItem(Storage.getKey(key, core));
            if (value == null)
            {
                return defaultValue;
            }
            try
            {
                return JSON.parse(value);
            }
            catch (err)
            {
                return defaultValue;
            }
        }

        private static getKey(key: string,core: boolean = false)
        {
            if (core)
            {
                return `red7/rscore/${RS.Version}/key`;
            }
            if (Storage._gameName == null || Storage._version == null)
            {
                Log.error("RS.Storage.getKey: Accessing Local Storage without initialising RS.Storage.");
            }
            return `red7/${Storage._gameName}/${Storage._version}/${key}`;
        }
    }
}
